import React from 'react';
import { motion } from 'framer-motion';

const SectionHeader = ({
  title,
  subtitle,
  badge,
  align = 'center',
  className = '',
  titleClassName = '',
  subtitleClassName = '',
  gradient = false,
}) => {
  const alignments = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto',
  };

  return (
    <motion.div
      className={`mb-12 md:mb-16 max-w-3xl ${alignments[align]} ${className}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {badge && (
        <motion.span
          className="inline-block px-4 py-1.5 mb-4 text-sm font-medium text-primary-600 bg-primary-50 rounded-full"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          {badge}
        </motion.span>
      )}
      <h2
        className={`
          text-3xl md:text-4xl lg:text-5xl font-bold mb-4
          ${gradient ? 'bg-clip-text text-transparent bg-gradient-to-r from-primary-500 to-secondary-500' : 'text-dark-800'}
          ${titleClassName}
        `}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`text-lg md:text-xl text-dark-500 ${subtitleClassName}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeader;
